export default {
  en: {
    title: 'Sub-entities',
    pageTitle: 'Sub-entities - {0}',
    pageHeader: 'Sub-entities',
    entityName: 'Sub-entity',
    dataTableColumns: {
      name: 'Sub-entity name',
      companyNumber: 'Company number',
      website: 'Website',
      country: 'Country',
      sector: 'Sector',
      dateAdded: 'Date added',
      numSuppliers: 'Suppliers',
      numClients: 'Clients',
      numSuppliersReviewed: 'Suppliers reviewed',
      numSuppliersReviewedApproved: 'Reviewed (approved)',
      numSuppliersReviewedRejected: 'Reviewed (rejected)',
      avgSuppliersCompliance: 'Suppliers average compliance',
      labels: 'Labels',
    },
    dataTableFilters: {
      name: 'Sub-entity name',
      companyNumber: 'Company number',
      website: 'Website',
      country: 'Country',
      sector: 'Sector',
      dateAdded: 'Date added',
      numSuppliers: 'Number of suppliers',
      numClients: 'Number of clients',
      numSuppliersReviewed: 'Number of suppliers reviewed',
      numSuppliersReviewedApproved: 'Number of suppliers reviewed (approved)',
      numSuppliersReviewedRejected: 'Number of suppliers reviewed (rejected)',
      avgSuppliersCompliance: 'Average suppliers compliance',
      labels: 'Labels',
    },
    placeholders: {
      emptyTitle: 'Sub-entities',
      emptyDescription: 'No sub-entities could be found',
      errorTitle: 'Sub-entities',
      errorDescription: 'Failed fetching sub-entities',
    },
    misc: {
      deletedUser: 'deletedUser',
      filterResultsSubEntities: '{count} sub-entities | {count} sub-entity | {count} sub-entities',
      filterResultsOutOf: '{0} out of {1}',
      export: 'Export',
      exportError: 'There was an error attempting to export the current view',
    },
  },
};
